import Button from "@/lib/Button";
import Input from "@/lib/Input";
import useGetTeamSettings from "@/lib/queries/useGetTeamSettings";
import useUpdateTeamSettings from "@/lib/queries/useUpdateTeamSettings";
import SettingsSectionLayout from "@/lib/SettingsSectionLayout";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

export default function General() {
  const { teamSlug } = useParams();
  const [name, setName] = useState("");

  const teamSettings = useGetTeamSettings(teamSlug);
  useEffect(() => {
    setName(teamSettings?.name ?? "");
  }, [teamSettings]);

  const { mutate: save, isPending } = useUpdateTeamSettings();

  return (
    <SettingsSectionLayout title="General">
      <div className="flex flex-col gap-8">
        <Input
          label="Legal Business Name"
          placeholder="Enter business name"
          value={name}
          onChange={setName}
          width={300}
        />
        <Input
          disabled
          label="Team Slug"
          placeholder="Enter team slug"
          value={teamSlug!}
          onChange={() => {}}
          width={300}
        />
        <Button
          primary
          size="lg"
          disabled={name === teamSettings?.name}
          loading={isPending}
          onClick={() =>
            save({
              body: { name },
              params: {
                path: {
                  team_slug: teamSlug!,
                },
              },
            })
          }
        >
          Save Changes
        </Button>
      </div>
    </SettingsSectionLayout>
  );
}
